<template>
	<div id="huokepage">
		<div class="topBar">
			<topbar></topbar>
		</div>
		<div class="kht_body FlexBox">
			<leftbar></leftbar>
			<div class="content_box FlexItem">
				<pageswitch></pageswitch>
				<div class="paddOuter">
					<keep-alive>
						<router-view v-if="$route.meta.keepAlive"></router-view>
					</keep-alive>
					<router-view v-if="!$route.meta.keepAlive"></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import topbar from "views/huoke/components/topbar.vue";
	import leftbar from "views/huoke/components/leftbar.vue";
	import pageswitch from "@/components/tabulation/pageswitch.vue";
	export default {
		components: {
			topbar,
			leftbar,
			pageswitch,
		},
	}
</script>

<style scoped lang="scss">
	#huokepage {
		height: 100vh;
		width: 100%;
	}
	.paddOuter{
		padding: 10px;
	}
	.topBar {
		position: sticky;
		top: 0;
		z-index: 100;
		width: 100vw;
		height: 60px;
		box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
	}

	.kht_body {
		// border: solid 1px royalblue;
		width: 100%;
		height: calc(100% - 60px);

		.content_box {
			
			height: 100%;
			overflow: auto;
			// background-color: pink;
			// border: solid 1px #ff2667;
		}
	}
</style>